module.exports = __webpack_public_path__ + "img/chat-user3.e8e401c1.png";